import { useState } from "react";

/**
 * 🔍 useEmployeeFilters Hook
 * يدير جميع states الفلترة والبحث للموظفين والأرشيف
 */
export function useEmployeeFilters() {
  // ============== EMPLOYEE SEARCH & FILTER STATES ==============
  const [searchTerm, setSearchTerm] = useState("");
  // Identifier box: one value, plus which identifier it searches.
  // Searching both at once is useless — a short client code is a substring
  // of many national IDs — so the user picks one.
  const [searchClientCode, setSearchClientCode] = useState("");
  const [codeSearchField, setCodeSearchField] = useState("clientCode");
  const [filterDepartment, setFilterDepartment] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterCompany, setFilterCompany] = useState("");
  const [filterStatusSearch, setFilterStatusSearch] = useState("");
  const [filterCompanySearch, setFilterCompanySearch] = useState("");
  const [showAllEmployees, setShowAllEmployees] = useState(false);

  // ============== ARCHIVE FILTER STATES ==============
  const [archiveSearch, setArchiveSearch] = useState("");
  const [archiveFilterCompany, setArchiveFilterCompany] = useState("");
  const [archiveFilterDateFrom, setArchiveFilterDateFrom] = useState("");
  const [archiveFilterDateTo, setArchiveFilterDateTo] = useState("");
  const [archiveFilterWorkingCompany, setArchiveFilterWorkingCompany] = useState("");
  const [archiveFilterDepartment, setArchiveFilterDepartment] = useState("");
  const [archiveFilterCompanySearch, setArchiveFilterCompanySearch] = useState("");
  const [archiveFilterWorkingCompanySearch, setArchiveFilterWorkingCompanySearch] = useState("");
  const [archiveFilterDepartmentSearch, setArchiveFilterDepartmentSearch] = useState("");

  // ============== HELPER FUNCTION: CLEAR ALL FILTERS ==============
  const clearAllFilters = () => {
    setSearchTerm("");
    setSearchClientCode("");
    setCodeSearchField("clientCode");
    setFilterDepartment("");
    setFilterStatus("");
    setFilterCompany("");
    setFilterStatusSearch("");
    setFilterCompanySearch("");
    setShowAllEmployees(false);
  };

  const clearArchiveFilters = () => {
    setArchiveSearch("");
    setArchiveFilterCompany("");
    setArchiveFilterDateFrom("");
    setArchiveFilterDateTo("");
    setArchiveFilterWorkingCompany("");
    setArchiveFilterDepartment("");
    setArchiveFilterCompanySearch("");
    setArchiveFilterWorkingCompanySearch("");
    setArchiveFilterDepartmentSearch("");
  };

  // ============== RETURN PUBLIC API ==============
  return {
    // Employee filters
    searchTerm,
    setSearchTerm,
    searchClientCode,
    setSearchClientCode,
    codeSearchField,
    setCodeSearchField,
    filterDepartment,
    setFilterDepartment,
    filterStatus,
    setFilterStatus,
    filterCompany,
    setFilterCompany,
    filterStatusSearch,
    setFilterStatusSearch,
    filterCompanySearch,
    setFilterCompanySearch,
    showAllEmployees,
    setShowAllEmployees,

    // Archive filters
    archiveSearch,
    setArchiveSearch,
    archiveFilterCompany,
    setArchiveFilterCompany,
    archiveFilterDateFrom,
    setArchiveFilterDateFrom,
    archiveFilterDateTo,
    setArchiveFilterDateTo,
    archiveFilterWorkingCompany,
    setArchiveFilterWorkingCompany,
    archiveFilterDepartment,
    setArchiveFilterDepartment,
    archiveFilterCompanySearch,
    setArchiveFilterCompanySearch,
    archiveFilterWorkingCompanySearch,
    setArchiveFilterWorkingCompanySearch,
    archiveFilterDepartmentSearch,
    setArchiveFilterDepartmentSearch,

    // Helper methods
    clearAllFilters,
    clearArchiveFilters,
  };
}
